@if (performance) {
  <!--  {{ performance.datetime }}-->
  <table>
    <tr [class]="performance.datetime.split('T')[0] === today ? 'today' : ''">
      <td class="datum" data-label="Datum">{{ performance.datetime.split('T')[0] | logShowDate }}
        <br>{{ performance.datetime | performanceAanvangTijd }}
        </td>
        <td class="notitie" data-label="Notitie">{{ performance.notes || '-' }}</td>
        <td [class]="getEarlyShiftBackgroundColor(performance, performance.earlyShiftForStagemanager)" class="crew"
          data-label="Stagemanager">
          <div style="display: grid; grid-template-columns: auto 20px; align-items: center;">
            <div class="tooltip">{{ performance.scheduledStagemanager?.firstName ?? '-' }}
              @if (performance.scheduledStagemanager) {
                <span
                class="tooltiptext">{{ performance.scheduledStagemanager?.getFullName() }}</span>
              }
            </div>
            @if (performance.earlyShiftForStagemanager) {
              <ion-icon class="early-shift-icon"
              name="alarm-outline"></ion-icon>
            }
          </div>
        </td>
        <td [class]="getEarlyShiftBackgroundColor(performance, performance.earlyShiftForShowcaller)" class="crew"
          data-label="Showcaller">
          <div style="display: grid; grid-template-columns: auto 20px; align-items: center;">
            <div class="tooltip">{{ performance.scheduledShowcaller?.firstName ?? '-' }}
              @if (performance.scheduledShowcaller) {
                <span
                class="tooltiptext">{{ performance.scheduledShowcaller?.getFullName() }}</span>
              }
            </div>
            @if (performance.earlyShiftForShowcaller) {
              <ion-icon class="early-shift-icon"
              name="alarm-outline"></ion-icon>
            }
          </div>
        </td>
        <td [class]="getEarlyShiftBackgroundColor(performance, performance.earlyShiftForFloortechnician)" class="crew"
          data-label="2e Inspicient">
          <div style="display: grid; grid-template-columns: auto 20px; align-items: center;">
            <div class="tooltip">{{ performance.scheduledFloortechnician?.firstName ?? '-' }}
              @if (performance.scheduledFloortechnician) {
                <span
                class="tooltiptext">{{ performance.scheduledFloortechnician?.getFullName() }}</span>
              }
            </div>
            @if (performance.earlyShiftForFloortechnician) {
              <ion-icon class="early-shift-icon"
              name="alarm-outline"></ion-icon>
            }
          </div>
        </td>
        <td [class]="getEarlyShiftBackgroundColor(performance, performance.earlyShiftForTroubleshooter)" class="crew"
          data-label="Troubleshooter">
          <div style="display: grid; grid-template-columns: auto 20px; align-items: center;">
            <div class="tooltip">{{ performance.scheduledTroubleshooter?.firstName ?? '-' }}
              @if (performance.scheduledTroubleshooter) {
                <span
                class="tooltiptext">{{ performance.scheduledTroubleshooter?.getFullName() }}</span>
              }
            </div>
            @if (performance.earlyShiftForTroubleshooter) {
              <ion-icon class="early-shift-icon"
              name="alarm-outline"></ion-icon>
            }
          </div>
        </td>
        <td [class]="getEarlyShiftBackgroundColor(performance, performance.earlyShiftForToneelmeester)" class="crew"
          data-label="Toneelmeester">
          <div style="display: grid; grid-template-columns: auto 20px; align-items: center;">
            <div class="tooltip">{{ performance.scheduledToneelmeester?.firstName ?? '-' }}
              @if (performance.scheduledToneelmeester) {
                <span
                class="tooltiptext">{{ performance.scheduledToneelmeester?.getFullName() }}</span>
              }
            </div>
            @if (performance.earlyShiftForToneelmeester) {
              <ion-icon class="early-shift-icon"
              name="alarm-outline"></ion-icon>
            }
          </div>
        </td>
        <td [class]="getEarlyShiftBackgroundColor(performance, performance.earlyShiftForExtraCrew)" class="crew"
          data-label="Meeloop / Extra">
          <div style="display: grid; grid-template-columns: auto 20px; align-items: center;">
            <div class="tooltip">{{ performance.extraCrew ?? '-' }}
              @if (performance.extraCrew) {
                <span class="tooltiptext">{{ performance.extraCrew }}</span>
              }
            </div>
            @if (performance.earlyShiftForExtraCrew) {
              <ion-icon class="early-shift-icon"
              name="alarm-outline"></ion-icon>
            }
          </div>
        </td>
        @if (canEditPerformances()) {
          <td class="buttons">
            @if (canEditPerformances()) {
              <ion-button (click)="navigateToPerformanceEditPage(performance)"
                fill="clear" size="small">
                <ion-icon name="pencil" slot="icon-only"></ion-icon>
              </ion-button>
            }
          </td>
        }
      </tr>
    </table>
  }
